import React, { FC } from 'react';

import NotificationsIndex from '@buyside/components/presentation/NotificationsIndex/notificationsIndex';

const NotificationsIndexPageRoot: FC = () => {
  return <NotificationsIndex />;
};

export default NotificationsIndexPageRoot;
